import type { AxiosProgressEvent } from "axios";
import { multiUserApi } from "../../../../shared/utils/multiUserFunctions";
import { appAudioTranscriptionApi } from "../../config/apiConfig";
import type {
  AudioTranscriptionGetResponse,
  AudioTranscriptionPostResponse,
} from "./types";
import { audioTranscriptionToken } from "./constants";

export const postAudioTranscription = (
  file: File,
  onUploadProgress?: (event: AxiosProgressEvent) => void,
): Promise<AudioTranscriptionPostResponse> => {
  const formData = new FormData();
  formData.append("file", file);

  return appAudioTranscriptionApi
    .post("/recognize", formData, {
      headers: {
        Authorization: audioTranscriptionToken,
        File: encodeURIComponent(file.name),
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
      onUploadProgress,
      withCredentials: false,
    })
    .then((res) => res.data);
};

export const postAudioTranscriptionLocal = (
  file: File,
  onUploadProgress?: (event: AxiosProgressEvent) => void,
): Promise<AudioTranscriptionPostResponse> => {
  const formData = new FormData();
  formData.append("file", file);

  return appAudioTranscriptionApi
    .post("/recognize/local", formData, {
      headers: {
        Authorization: audioTranscriptionToken,
        File: encodeURIComponent(file.name),
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
      onUploadProgress,
      withCredentials: false,
    })
    .then((res) => res.data);
};

export const getAudioTranscription = (
  hash: string,
  signal: AbortSignal,
): Promise<AudioTranscriptionGetResponse> => {
  return appAudioTranscriptionApi
    .get("/recognize/" + hash, {
      headers: {
        Authorization: audioTranscriptionToken,
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
      withCredentials: false,
      signal,
    })
    .then((res) => res.data);
};
